import Immutable from 'seamless-immutable'
import * as types from './types'

export const INITIAL_STATE = Immutable({
  fetching: false,
  received: false,
  list: [],
  wallets: {
    list: [],
    fetching: false,
    pagination: null
  },
  detail: null,
  pagination: null
})

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.FETCH_LIST: {
      const newState = state.setIn(['fetching'], action.payload)

      return newState
    }

    case types.RECEIVE_LIST: {
      const newState = state
        .setIn(['fetching'], false)
        .setIn(['list'], action.payload.data)
        .setIn(['pagination'], action.payload.pagination)

      return newState
    }

    case types.FETCH_DETAIL: {
      const newState = state.setIn(['fetching'], action.payload)
      return newState
    }

    case types.RECEIVE_DETAIL: {
      const newState = state.setIn(['detail'], action.payload)

      return newState
    }

    case types.FETCH_WALLET_SUPERVISED: {
      const newState = state.setIn(['wallets', 'fetching'], action.payload)
      return newState
    }

    case types.RECEIVE_WALLET_SUPERVISED: {
      const newState = state
        .setIn(['wallets', 'list'], action.payload.data)
        .setIn(['wallets', 'pagination'], action.payload.pagination)

      return newState
    }

    case types.CLEAR_LIST: {
      const newState = state.setIn(['list'], []).setIn(['pagination'], null)
      return newState
    }

    case types.CLEAR_DETAIL: {
      const newState = state.setIn(['detail'], null)
      return newState
    }

    case types.CLEAR_WALLET_SUPERVISED: {
      const newState = state
        .setIn(['wallets', 'list'], [])
        .setIn(['wallets', 'pagination'], [])
      return newState
    }

    default: {
      return state
    }
  }
}

export default reducer
